import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "market_icon_check",
  "use": "market_icon_check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"market_icon_check\">\n<g id=\"market_icon_check_Frame\">\n<path id=\"market_icon_check_Vector\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33325 8L2.99992 6.33333L6.33325 9.66667L12.9999 3L14.6666 4.66667L6.33325 13L1.33325 8Z\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol